module.exports = __webpack_public_path__ + "img/papillary-reaction-3.557f2c23.jpg";